import { useSyncExternalStore } from "react";
import {
  type LucideIcon,
  Anchor as Ic_Anchor,
  Apple as Ic_Apple,
  Baby as Ic_Baby,
  Backpack as Ic_Backpack,
  BadgePercent as Ic_BadgePercent,
  Banana as Ic_Banana,
  Bandage as Ic_Bandage,
  Bath as Ic_Bath,
  Battery as Ic_Battery,
  Beaker as Ic_Beaker,
  Bed as Ic_Bed,
  Beef as Ic_Beef,
  Beer as Ic_Beer,
  Bell as Ic_Bell,
  Bike as Ic_Bike,
  BookOpen as Ic_BookOpen,
  BottleWine as Ic_BottleWine,
  Briefcase as Ic_Briefcase,
  Brush as Ic_Brush,
  Bug as Ic_Bug,
  Building2 as Ic_Building2,
  Bus as Ic_Bus,
  Cake as Ic_Cake,
  Calculator as Ic_Calculator,
  Calendar as Ic_Calendar,
  Camera as Ic_Camera,
  Candy as Ic_Candy,
  Car as Ic_Car,
  CarFront as Ic_CarFront,
  Carrot as Ic_Carrot,
  Cast as Ic_Cast,
  Cat as Ic_Cat,
  ChefHat as Ic_ChefHat,
  Cherry as Ic_Cherry,
  Church as Ic_Church,
  Cigarette as Ic_Cigarette,
  Citrus as Ic_Citrus,
  Clapperboard as Ic_Clapperboard,
  Clipboard as Ic_Clipboard,
  Clock as Ic_Clock,
  Cloud as Ic_Cloud,
  Coffee as Ic_Coffee,
  Coins as Ic_Coins,
  Compass as Ic_Compass,
  Computer as Ic_Computer,
  Cookie as Ic_Cookie,
  CookingPot as Ic_CookingPot,
  CreditCard as Ic_CreditCard,
  Croissant as Ic_Croissant,
  Crown as Ic_Crown,
  CupSoda as Ic_CupSoda,
  Currency as Ic_Currency,
  Cylinder as Ic_Cylinder,
  Diamond as Ic_Diamond,
  Dices as Ic_Dices,
  Disc as Ic_Disc,
  Dog as Ic_Dog,
  Donut as Ic_Donut,
  Drama as Ic_Drama,
  Drill as Ic_Drill,
  Drum as Ic_Drum,
  Drumstick as Ic_Drumstick,
  Dumbbell as Ic_Dumbbell,
  Ear as Ic_Ear,
  Egg as Ic_Egg,
  Eraser as Ic_Eraser,
  EthernetPort as Ic_EthernetPort,
  Eye as Ic_Eye,
  Factory as Ic_Factory,
  Fan as Ic_Fan,
  Feather as Ic_Feather,
  Film as Ic_Film,
  Filter as Ic_Filter,
  Fish as Ic_Fish,
  FishSymbol as Ic_FishSymbol,
  Flag as Ic_Flag,
  Flame as Ic_Flame,
  Flashlight as Ic_Flashlight,
  FlaskConical as Ic_FlaskConical,
  Flower as Ic_Flower,
  Flower2 as Ic_Flower2,
  Folder as Ic_Folder,
  Footprints as Ic_Footprints,
  Forklift as Ic_Forklift,
  Fuel as Ic_Fuel,
  Gamepad as Ic_Gamepad,
  Gamepad2 as Ic_Gamepad2,
  Gem as Ic_Gem,
  Gift as Ic_Gift,
  GlassWater as Ic_GlassWater,
  Glasses as Ic_Glasses,
  Globe as Ic_Globe,
  Grape as Ic_Grape,
  Grid3x3 as Ic_Grid3x3,
  Guitar as Ic_Guitar,
  Hammer as Ic_Hammer,
  Hand as Ic_Hand,
  HandCoins as Ic_HandCoins,
  Handshake as Ic_Handshake,
  HardDrive as Ic_HardDrive,
  HardHat as Ic_HardHat,
  Headphones as Ic_Headphones,
  Heart as Ic_Heart,
  HeartPulse as Ic_HeartPulse,
  Home as Ic_Home,
  IceCream as Ic_IceCream,
  IceCream2 as Ic_IceCream2,
  Image as Ic_Image,
  Inbox as Ic_Inbox,
  Joystick as Ic_Joystick,
  Key as Ic_Key,
  Keyboard as Ic_Keyboard,
  Lamp as Ic_Lamp,
  LampDesk as Ic_LampDesk,
  Landmark as Ic_Landmark,
  Laptop as Ic_Laptop,
  Layers as Ic_Layers,
  Leaf as Ic_Leaf,
  Lightbulb as Ic_Lightbulb,
  Lock as Ic_Lock,
  Luggage as Ic_Luggage,
  Magnet as Ic_Magnet,
  Mail as Ic_Mail,
  Map as Ic_Map,
  MapPin as Ic_MapPin,
  Martini as Ic_Martini,
  Medal as Ic_Medal,
  Megaphone as Ic_Megaphone,
  MessageCircle as Ic_MessageCircle,
  Mic as Ic_Mic,
  Milk as Ic_Milk,
  Monitor as Ic_Monitor,
  Moon as Ic_Moon,
  Mountain as Ic_Mountain,
  Mouse as Ic_Mouse,
  Music as Ic_Music,
  NotebookPen as Ic_NotebookPen,
  PaintBucket as Ic_PaintBucket,
  Paintbrush as Ic_Paintbrush,
  Palette as Ic_Palette,
  Palmtree as Ic_Palmtree,
  Paperclip as Ic_Paperclip,
  ParkingCircle as Ic_ParkingCircle,
  PartyPopper as Ic_PartyPopper,
  PawPrint as Ic_PawPrint,
  Pen as Ic_Pen,
  Pencil as Ic_Pencil,
  PersonStanding as Ic_PersonStanding,
  PhoneCall as Ic_PhoneCall,
  PiggyBank as Ic_PiggyBank,
  Pill as Ic_Pill,
  Pizza as Ic_Pizza,
  Plane as Ic_Plane,
  Plug as Ic_Plug,
  Plus as Ic_Plus,
  Popcorn as Ic_Popcorn,
  Power as Ic_Power,
  Printer as Ic_Printer,
  Puzzle as Ic_Puzzle,
  Pyramid as Ic_Pyramid,
  Radio as Ic_Radio,
  Receipt as Ic_Receipt,
  Recycle as Ic_Recycle,
  Refrigerator as Ic_Refrigerator,
  Repeat as Ic_Repeat,
  Rocket as Ic_Rocket,
  Ruler as Ic_Ruler,
  Salad as Ic_Salad,
  Sandwich as Ic_Sandwich,
  Satellite as Ic_Satellite,
  Scale as Ic_Scale,
  Scissors as Ic_Scissors,
  Settings as Ic_Settings,
  Shapes as Ic_Shapes,
  Shell as Ic_Shell,
  Shield as Ic_Shield,
  Ship as Ic_Ship,
  Shirt as Ic_Shirt,
  ShoppingBag as Ic_ShoppingBag,
  ShoppingBasket as Ic_ShoppingBasket,
  ShoppingCart as Ic_ShoppingCart,
  Shovel as Ic_Shovel,
  Shrub as Ic_Shrub,
  Signal as Ic_Signal,
  Sliders as Ic_Sliders,
  Smartphone as Ic_Smartphone,
  SmartphoneCharging as Ic_SmartphoneCharging,
  Smile as Ic_Smile,
  Snowflake as Ic_Snowflake,
  Soup as Ic_Soup,
  Sparkles as Ic_Sparkles,
  Speaker as Ic_Speaker,
  Sprout as Ic_Sprout,
  Square as Ic_Square,
  Squirrel as Ic_Squirrel,
  Stamp as Ic_Stamp,
  Star as Ic_Star,
  Stethoscope as Ic_Stethoscope,
  Sticker as Ic_Sticker,
  Store as Ic_Store,
  Sun as Ic_Sun,
  Swords as Ic_Swords,
  Syringe as Ic_Syringe,
  Tablet as Ic_Tablet,
  Tag as Ic_Tag,
  Target as Ic_Target,
  Tent as Ic_Tent,
  Thermometer as Ic_Thermometer,
  ThumbsUp as Ic_ThumbsUp,
  Ticket as Ic_Ticket,
  Timer as Ic_Timer,
  ToggleLeft as Ic_ToggleLeft,
  Tractor as Ic_Tractor,
  TrafficCone as Ic_TrafficCone,
  Train as Ic_Train,
  TreePine as Ic_TreePine,
  Trees as Ic_Trees,
  Trophy as Ic_Trophy,
  Truck as Ic_Truck,
  Tv as Ic_Tv,
  Umbrella as Ic_Umbrella,
  Usb as Ic_Usb,
  User as Ic_User,
  Utensils as Ic_Utensils,
  UtensilsCrossed as Ic_UtensilsCrossed,
  Vault as Ic_Vault,
  Vibrate as Ic_Vibrate,
  Volume2 as Ic_Volume2,
  Wallet as Ic_Wallet,
  Wand as Ic_Wand,
  Warehouse as Ic_Warehouse,
  Watch as Ic_Watch,
  Waves as Ic_Waves,
  Webcam as Ic_Webcam,
  Wheat as Ic_Wheat,
  Wifi as Ic_Wifi,
  Wind as Ic_Wind,
  Wine as Ic_Wine,
  Wrench as Ic_Wrench,
  Zap as Ic_Zap,
} from "lucide-react";
const ICON_REGISTRY: Record<string, LucideIcon> = {
  Anchor: Ic_Anchor,
  Apple: Ic_Apple,
  Baby: Ic_Baby,
  Backpack: Ic_Backpack,
  BadgePercent: Ic_BadgePercent,
  Banana: Ic_Banana,
  Bandage: Ic_Bandage,
  Bath: Ic_Bath,
  Battery: Ic_Battery,
  Beaker: Ic_Beaker,
  Bed: Ic_Bed,
  Beef: Ic_Beef,
  Beer: Ic_Beer,
  Bell: Ic_Bell,
  Bike: Ic_Bike,
  BookOpen: Ic_BookOpen,
  BottleWine: Ic_BottleWine,
  Briefcase: Ic_Briefcase,
  Brush: Ic_Brush,
  Bug: Ic_Bug,
  Building2: Ic_Building2,
  Bus: Ic_Bus,
  Cake: Ic_Cake,
  Calculator: Ic_Calculator,
  Calendar: Ic_Calendar,
  Camera: Ic_Camera,
  Candy: Ic_Candy,
  Car: Ic_Car,
  CarFront: Ic_CarFront,
  Carrot: Ic_Carrot,
  Cast: Ic_Cast,
  Cat: Ic_Cat,
  ChefHat: Ic_ChefHat,
  Cherry: Ic_Cherry,
  Church: Ic_Church,
  Cigarette: Ic_Cigarette,
  Citrus: Ic_Citrus,
  Clapperboard: Ic_Clapperboard,
  Clipboard: Ic_Clipboard,
  Clock: Ic_Clock,
  Cloud: Ic_Cloud,
  Coffee: Ic_Coffee,
  Coins: Ic_Coins,
  Compass: Ic_Compass,
  Computer: Ic_Computer,
  Cookie: Ic_Cookie,
  CookingPot: Ic_CookingPot,
  CreditCard: Ic_CreditCard,
  Croissant: Ic_Croissant,
  Crown: Ic_Crown,
  CupSoda: Ic_CupSoda,
  Currency: Ic_Currency,
  Cylinder: Ic_Cylinder,
  Diamond: Ic_Diamond,
  Dices: Ic_Dices,
  Disc: Ic_Disc,
  Dog: Ic_Dog,
  Donut: Ic_Donut,
  Drama: Ic_Drama,
  Drill: Ic_Drill,
  Drum: Ic_Drum,
  Drumstick: Ic_Drumstick,
  Dumbbell: Ic_Dumbbell,
  Ear: Ic_Ear,
  Egg: Ic_Egg,
  Eraser: Ic_Eraser,
  EthernetPort: Ic_EthernetPort,
  Eye: Ic_Eye,
  Factory: Ic_Factory,
  Fan: Ic_Fan,
  Feather: Ic_Feather,
  Film: Ic_Film,
  Filter: Ic_Filter,
  Fish: Ic_Fish,
  FishSymbol: Ic_FishSymbol,
  Flag: Ic_Flag,
  Flame: Ic_Flame,
  Flashlight: Ic_Flashlight,
  FlaskConical: Ic_FlaskConical,
  Flower: Ic_Flower,
  Flower2: Ic_Flower2,
  Folder: Ic_Folder,
  Footprints: Ic_Footprints,
  Forklift: Ic_Forklift,
  Fuel: Ic_Fuel,
  Gamepad: Ic_Gamepad,
  Gamepad2: Ic_Gamepad2,
  Gem: Ic_Gem,
  Gift: Ic_Gift,
  GlassWater: Ic_GlassWater,
  Glasses: Ic_Glasses,
  Globe: Ic_Globe,
  Grape: Ic_Grape,
  Grid3x3: Ic_Grid3x3,
  Guitar: Ic_Guitar,
  Hammer: Ic_Hammer,
  Hand: Ic_Hand,
  HandCoins: Ic_HandCoins,
  Handshake: Ic_Handshake,
  HardDrive: Ic_HardDrive,
  HardHat: Ic_HardHat,
  Headphones: Ic_Headphones,
  Heart: Ic_Heart,
  HeartPulse: Ic_HeartPulse,
  Home: Ic_Home,
  IceCream: Ic_IceCream,
  IceCream2: Ic_IceCream2,
  Image: Ic_Image,
  Inbox: Ic_Inbox,
  Joystick: Ic_Joystick,
  Key: Ic_Key,
  Keyboard: Ic_Keyboard,
  Lamp: Ic_Lamp,
  LampDesk: Ic_LampDesk,
  Landmark: Ic_Landmark,
  Laptop: Ic_Laptop,
  Layers: Ic_Layers,
  Leaf: Ic_Leaf,
  Lightbulb: Ic_Lightbulb,
  Lock: Ic_Lock,
  Luggage: Ic_Luggage,
  Magnet: Ic_Magnet,
  Mail: Ic_Mail,
  Map: Ic_Map,
  MapPin: Ic_MapPin,
  Martini: Ic_Martini,
  Medal: Ic_Medal,
  Megaphone: Ic_Megaphone,
  MessageCircle: Ic_MessageCircle,
  Mic: Ic_Mic,
  Milk: Ic_Milk,
  Monitor: Ic_Monitor,
  Moon: Ic_Moon,
  Mountain: Ic_Mountain,
  Mouse: Ic_Mouse,
  Music: Ic_Music,
  NotebookPen: Ic_NotebookPen,
  PaintBucket: Ic_PaintBucket,
  Paintbrush: Ic_Paintbrush,
  Palette: Ic_Palette,
  Palmtree: Ic_Palmtree,
  Paperclip: Ic_Paperclip,
  ParkingCircle: Ic_ParkingCircle,
  PartyPopper: Ic_PartyPopper,
  PawPrint: Ic_PawPrint,
  Pen: Ic_Pen,
  Pencil: Ic_Pencil,
  PersonStanding: Ic_PersonStanding,
  PhoneCall: Ic_PhoneCall,
  PiggyBank: Ic_PiggyBank,
  Pill: Ic_Pill,
  Pizza: Ic_Pizza,
  Plane: Ic_Plane,
  Plug: Ic_Plug,
  Plus: Ic_Plus,
  Popcorn: Ic_Popcorn,
  Power: Ic_Power,
  Printer: Ic_Printer,
  Puzzle: Ic_Puzzle,
  Pyramid: Ic_Pyramid,
  Radio: Ic_Radio,
  Receipt: Ic_Receipt,
  Recycle: Ic_Recycle,
  Refrigerator: Ic_Refrigerator,
  Repeat: Ic_Repeat,
  Rocket: Ic_Rocket,
  Ruler: Ic_Ruler,
  Salad: Ic_Salad,
  Sandwich: Ic_Sandwich,
  Satellite: Ic_Satellite,
  Scale: Ic_Scale,
  Scissors: Ic_Scissors,
  Settings: Ic_Settings,
  Shapes: Ic_Shapes,
  Shell: Ic_Shell,
  Shield: Ic_Shield,
  Ship: Ic_Ship,
  Shirt: Ic_Shirt,
  ShoppingBag: Ic_ShoppingBag,
  ShoppingBasket: Ic_ShoppingBasket,
  ShoppingCart: Ic_ShoppingCart,
  Shovel: Ic_Shovel,
  Shrub: Ic_Shrub,
  Signal: Ic_Signal,
  Sliders: Ic_Sliders,
  Smartphone: Ic_Smartphone,
  SmartphoneCharging: Ic_SmartphoneCharging,
  Smile: Ic_Smile,
  Snowflake: Ic_Snowflake,
  Soup: Ic_Soup,
  Sparkles: Ic_Sparkles,
  Speaker: Ic_Speaker,
  Sprout: Ic_Sprout,
  Square: Ic_Square,
  Squirrel: Ic_Squirrel,
  Stamp: Ic_Stamp,
  Star: Ic_Star,
  Stethoscope: Ic_Stethoscope,
  Sticker: Ic_Sticker,
  Store: Ic_Store,
  Sun: Ic_Sun,
  Swords: Ic_Swords,
  Syringe: Ic_Syringe,
  Tablet: Ic_Tablet,
  Tag: Ic_Tag,
  Target: Ic_Target,
  Tent: Ic_Tent,
  Thermometer: Ic_Thermometer,
  ThumbsUp: Ic_ThumbsUp,
  Ticket: Ic_Ticket,
  Timer: Ic_Timer,
  ToggleLeft: Ic_ToggleLeft,
  Tractor: Ic_Tractor,
  TrafficCone: Ic_TrafficCone,
  Train: Ic_Train,
  TreePine: Ic_TreePine,
  Trees: Ic_Trees,
  Trophy: Ic_Trophy,
  Truck: Ic_Truck,
  Tv: Ic_Tv,
  Umbrella: Ic_Umbrella,
  Usb: Ic_Usb,
  User: Ic_User,
  Utensils: Ic_Utensils,
  UtensilsCrossed: Ic_UtensilsCrossed,
  Vault: Ic_Vault,
  Vibrate: Ic_Vibrate,
  Volume2: Ic_Volume2,
  Wallet: Ic_Wallet,
  Wand: Ic_Wand,
  Warehouse: Ic_Warehouse,
  Watch: Ic_Watch,
  Waves: Ic_Waves,
  Webcam: Ic_Webcam,
  Wheat: Ic_Wheat,
  Wifi: Ic_Wifi,
  Wind: Ic_Wind,
  Wine: Ic_Wine,
  Wrench: Ic_Wrench,
  Zap: Ic_Zap,
};
const REGISTRY_ICONS: LucideIcon[] = Object.values(ICON_REGISTRY);

// Keyword → list of preferred icons (Greek + English). First available wins.
const RULES: { keywords: string[]; icons: string[] }[] = [
  { keywords: ["μήλ", "apple"], icons: ["Apple"] },
  { keywords: ["μπανάν", "banana"], icons: ["Banana"] },
  { keywords: ["σταφύλ", "grape"], icons: ["Grape"] },
  { keywords: ["κεράσι", "βυσσιν", "cherry"], icons: ["Cherry"] },
  { keywords: ["εσπεριδ", "λεμον", "πορτοκάλ", "citrus", "lemon", "orange"], icons: ["Citrus"] },
  { keywords: ["καρότ", "λαχαν", "carrot", "vegetable"], icons: ["Carrot", "Salad"] },
  { keywords: ["σαλάτ", "salad"], icons: ["Salad"] },
  { keywords: ["σούπ", "soup"], icons: ["Soup"] },
  { keywords: ["κρέα", "μοσχάρι", "χοιριν", "beef", "meat"], icons: ["Beef", "Drumstick"] },
  { keywords: ["κοτόπουλ", "πουλερικ", "chicken"], icons: ["Drumstick"] },
  { keywords: ["ψάρι", "ψαρι", "θαλασσιν", "fish", "seafood"], icons: ["Fish", "FishSymbol", "Shell"] },
  { keywords: ["αυγ", "egg"], icons: ["Egg"] },
  { keywords: ["γάλα", "γαλακτ", "milk", "dairy"], icons: ["Milk"] },
  { keywords: ["τυρ", "cheese"], icons: ["Cake"] },
  { keywords: ["ψωμ", "αρτοσκευ", "αλεύρ", "bread"], icons: ["Wheat"] },
  { keywords: ["δημητρ", "cereal"], icons: ["Wheat"] },
  { keywords: ["κρουασ", "ζύμη", "ζυμαρ"], icons: ["Croissant"] },
  { keywords: ["τούρτ", "γλυκ", "ζαχαροπλ", "cake", "dessert"], icons: ["Cake", "IceCream", "IceCream2", "Donut"] },
  { keywords: ["παγωτ", "ice"], icons: ["IceCream", "IceCream2"] },
  { keywords: ["μπισκότ", "cookie"], icons: ["Cookie"] },
  { keywords: ["καραμέλ", "ζαχαρωτ", "candy", "sweet"], icons: ["Candy"] },
  { keywords: ["σοκολ", "chocolate"], icons: ["Cookie"] },
  { keywords: ["πίτσα", "pizza"], icons: ["Pizza"] },
  { keywords: ["σάντουιτ", "sandwich"], icons: ["Sandwich"] },
  { keywords: ["μαγειρ", "chef", "κουζίν", "cook"], icons: ["ChefHat", "CookingPot", "Utensils", "UtensilsCrossed"] },
  { keywords: ["καφέ", "coffee"], icons: ["Coffee"] },
  { keywords: ["τσάι", "tea"], icons: ["Coffee"] },
  { keywords: ["νερ", "water"], icons: ["GlassWater"] },
  { keywords: ["αναψυκτ", "soda", "soft drink"], icons: ["CupSoda"] },
  { keywords: ["χυμ", "juice"], icons: ["CupSoda", "GlassWater"] },
  { keywords: ["κρασ", "wine"], icons: ["Wine", "BottleWine"] },
  { keywords: ["μπύρ", "beer"], icons: ["Beer"] },
  { keywords: ["κοκτ", "cocktail"], icons: ["Martini"] },
  { keywords: ["ποτ", "οινοπνευμ", "alcohol", "liquor"], icons: ["Martini", "Wine", "BottleWine"] },
  { keywords: ["μωρ", "βρεφ", "baby"], icons: ["Baby"] },
  { keywords: ["παιδ", "kid", "child"], icons: ["Baby", "Gamepad2"] },
  { keywords: ["παιχνίδ", "game", "toy"], icons: ["Gamepad2", "Gamepad", "Dices", "Puzzle"] },
  { keywords: ["κατοικίδ", "ζώ", "pet"], icons: ["PawPrint"] },
  { keywords: ["σκύλ", "dog"], icons: ["Dog"] },
  { keywords: ["γάτ", "cat"], icons: ["Cat"] },
  { keywords: ["πτηνά", "πουλι", "bird"], icons: ["Feather"] },
  { keywords: ["μέλισσ", "bee"], icons: ["Bug"] },
  { keywords: ["καθαρ", "βούρτσ", "brush", "clean"], icons: ["Brush", "Paintbrush", "PaintBucket", "Sparkles"] },
  { keywords: ["απορρυπ", "detergent"], icons: ["FlaskConical", "Sparkles"] },
  { keywords: ["καλλυντ", "ομορφι", "beauty", "cosmetic"], icons: ["Sparkles"] },
  { keywords: ["άρωμα", "perfume"], icons: ["FlaskConical"] },
  { keywords: ["μακιγιά", "makeup"], icons: ["Palette"] },
  { keywords: ["φάρμακ", "χάπ", "pharma", "medicine"], icons: ["Pill"] },
  { keywords: ["υγεί", "health"], icons: ["HeartPulse", "Stethoscope"] },
  { keywords: ["πρώτες βοήθειες", "first aid", "bandage"], icons: ["Stethoscope"] },
  { keywords: ["οδοντ", "tooth", "dental"], icons: ["Smile"] },
  { keywords: ["μάτι", "οπτικ", "γυαλι", "eye", "vision", "glass"], icons: ["Glasses", "Eye"] },
  { keywords: ["ρούχ", "ένδυσ", "μπλούζ", "shirt", "clothing", "apparel"], icons: ["Shirt"] },
  { keywords: ["παπούτσ", "υπόδησ", "shoe", "boot"], icons: ["Footprints"] },
  { keywords: ["τσάντ", "σακιδ", "bag", "backpack"], icons: ["ShoppingBag", "Backpack", "Briefcase"] },
  { keywords: ["κοσμημ", "jewel"], icons: ["Gem", "Diamond", "Crown"] },
  { keywords: ["ρολοι", "watch"], icons: ["Watch"] },
  { keywords: ["βιβλί", "book"], icons: ["BookOpen"] },
  { keywords: ["γραφικ ύλ", "stationery", "office"], icons: ["Pencil", "Pen", "Paperclip", "NotebookPen", "Clipboard"] },
  { keywords: ["σχολικ", "school"], icons: ["Backpack", "NotebookPen"] },
  { keywords: ["μουσικ", "music", "instrument"], icons: ["Music", "Guitar", "Drum", "Mic"] },
  { keywords: ["ταινί", "κινηματογρ", "movie", "film"], icons: ["Clapperboard", "Film"] },
  { keywords: ["τηλεόρασ", "tv"], icons: ["Tv", "Monitor"] },
  { keywords: ["ακουστικ", "ήχ", "audio", "headphone", "speaker"], icons: ["Headphones", "Speaker", "Volume2"] },
  { keywords: ["ραδι", "radio"], icons: ["Radio"] },
  { keywords: ["κάμερ", "φωτογραφ", "camera", "photo"], icons: ["Camera", "Webcam"] },
  { keywords: ["κινητ", "phone", "smartphone"], icons: ["Smartphone", "SmartphoneCharging", "PhoneCall"] },
  { keywords: ["tablet", "ταμπλέτ"], icons: ["Tablet"] },
  { keywords: ["laptop", "φορητός υπ"], icons: ["Laptop"] },
  { keywords: ["υπολογιστ", "computer", "pc"], icons: ["Computer", "Monitor", "Laptop"] },
  { keywords: ["πληκτρολ", "keyboard"], icons: ["Keyboard"] },
  { keywords: ["ποντίκι", "mouse"], icons: ["Mouse"] },
  { keywords: ["εκτυπωτ", "printer"], icons: ["Printer"] },
  { keywords: ["εργαλεί", "tool"], icons: ["Hammer", "Wrench", "Drill"] },
  { keywords: ["κατσαβ", "screwdriver"], icons: ["Wrench"] },
  { keywords: ["σιδερ", "iron", "metal"], icons: ["Wrench"] },
  { keywords: ["κήπ", "garden"], icons: ["Sprout", "Trees", "TreePine", "Shrub"] },
  { keywords: ["φυτ", "plant"], icons: ["Sprout", "Leaf"] },
  { keywords: ["λουλούδ", "ανθο", "flower"], icons: ["Flower", "Flower2"] },
  { keywords: ["βιολογ", "bio", "organic"], icons: ["Leaf"] },
  { keywords: ["καύσιμ", "fuel", "πετρέλ"], icons: ["Fuel"] },
  { keywords: ["θέρμανσ", "heating", "fire"], icons: ["Flame"] },
  { keywords: ["κλιματ", "ψύξ", "ac", "cooling"], icons: ["Snowflake", "Wind"] },
  { keywords: ["φωτισμ", "λάμπ", "light"], icons: ["Lightbulb", "Lamp", "LampDesk", "Flashlight"] },
  { keywords: ["ηλεκτρ", "electric", "πρίζ"], icons: ["Plug", "Zap", "Battery"] },
  { keywords: ["ενέργ", "μπαταρ", "energy", "battery"], icons: ["Battery", "Zap"] },
  { keywords: ["ψυγει", "fridge"], icons: ["Refrigerator"] },
  { keywords: ["σπίτι", "οικιακ", "home", "household"], icons: ["Home"] },
  { keywords: ["έπιπλ", "furniture"], icons: ["Bed", "Lamp", "LampDesk"] },
  { keywords: ["κρεβ", "ύπν", "bed", "sleep"], icons: ["Bed"] },
  { keywords: ["μπάνι", "bath"], icons: ["Bath"] },
  { keywords: ["δώρ", "gift"], icons: ["Gift"] },
  { keywords: ["καλοκαιρ", "παραλι", "summer", "beach"], icons: ["Sun", "Umbrella", "Palmtree"] },
  { keywords: ["χειμων", "winter"], icons: ["Snowflake"] },
  { keywords: ["γιορτ", "πάρτι", "party", "celebrat"], icons: ["PartyPopper"] },
  { keywords: ["χριστουγ", "christmas"], icons: ["TreePine"] },
  { keywords: ["πάσχα", "easter"], icons: ["Egg"] },
  { keywords: ["αυτοκίν", "όχημα", "car"], icons: ["Car", "CarFront"] },
  { keywords: ["μηχαν", "moto"], icons: ["Bike"] },
  { keywords: ["ποδήλατ", "bike", "bicycle"], icons: ["Bike"] },
  { keywords: ["ταξίδ", "travel", "βαλίτσα", "luggage"], icons: ["Luggage", "Plane"] },
  { keywords: ["αθλητ", "γυμναστ", "sport", "fitness"], icons: ["Dumbbell", "Trophy", "Medal"] },
  { keywords: ["κάμπινγκ", "camp", "σκην"], icons: ["Tent"] },
  { keywords: ["προσφορ", "offer", "sale", "promo"], icons: ["BadgePercent", "Tag"] },
  { keywords: ["νέ", "νεες", "νεο", "νεας", "new", "arrival"], icons: ["Sparkles", "Star"] },
  { keywords: ["best", "δημοφιλ", "κορυφ", "top"], icons: ["Trophy", "Star", "Medal"] },
  { keywords: ["εργαστηρ", "lab"], icons: ["FlaskConical", "Beaker"] },
  { keywords: ["γραφεί", "office"], icons: ["Briefcase"] },
  { keywords: ["χαρτικ", "paper"], icons: ["Paperclip"] },
  { keywords: ["παρτή", "candle"], icons: ["Flame"] },
  { keywords: ["ασφάλ", "security", "lock"], icons: ["Lock", "Shield"] },
  { keywords: ["χρήμα", "money", "νόμισμα", "coin"], icons: ["Coins", "Wallet", "PiggyBank", "Currency"] },
];

// Pool of additional unique icons used when keyword rules don't match (or collide).
const FALLBACK_POOL: string[] = [
  "Tag", "Star", "Sparkles", "Diamond", "Gem", "Heart", "Bell", "Flag", "Crown",
  "Trophy", "Medal", "Ticket", "Compass", "Map", "MapPin", "Globe", "Rocket",
  "Shapes", "Pyramid", "Cylinder", "Square", "Layers", "Grid3x3", "Inbox",
  "Folder", "Image", "Sticker", "Stamp", "Receipt", "Calculator", "Calendar",
  "Clock", "Timer", "Target", "Wand", "PartyPopper", "Cloud", "Moon", "Mountain",
  "Waves", "Wind", "Snowflake", "Sun", "Feather", "Leaf", "Shrub", "TreePine",
  "Trees", "Bug", "Squirrel", "Cat", "Dog", "Drama", "Smile", "ThumbsUp",
  "Handshake", "HandCoins", "Hand", "Footprints", "Eye", "Ear", "User",
  "PersonStanding", "Megaphone", "Mail", "MessageCircle", "Signal", "Satellite",
  "Wifi", "Cast", "Disc", "Joystick", "Filter", "Sliders", "Settings",
  "ToggleLeft", "Power", "Plus", "Magnet", "Anchor", "Ship", "Bus", "Train",
  "Truck", "Forklift", "Tractor", "HardHat", "HardDrive", "EthernetPort",
  "Usb", "Key", "Vault", "Landmark", "Building2", "Factory", "Warehouse",
  "Store", "Church", "Tent", "ParkingCircle", "TrafficCone", "Recycle",
  "Repeat", "Scissors", "Shovel", "Scale", "Ruler", "Pencil", "Pen",
  "Eraser", "Clipboard", "Vibrate", "Yarn", "Bandage", "Syringe", "Thermometer",
  "Drama", "Popcorn", "Cigarette", "Swords", "ShoppingBasket", "ShoppingCart",
  "Backpack", "Briefcase", "Glasses", "Watch", "CreditCard", "Wallet",
  "Cookie", "Donut", "Sandwich", "Soup", "Salad", "Carrot", "Apple", "Banana",
  "Cherry", "Citrus", "Grape", "Egg", "Milk", "Cake", "Pizza", "Coffee",
  "Beer", "Wine", "Martini", "CupSoda", "GlassWater", "Beef", "Drumstick",
  "Fish", "FishSymbol", "Shell", "Pill", "Stethoscope", "HeartPulse",
  "Bath", "Bed", "Lamp", "Lightbulb", "Plug", "Battery", "Zap", "Hammer",
  "Wrench", "Drill", "PaintBucket", "Paintbrush", "Palette", "Brush",
  "Headphones", "Speaker", "Music", "Guitar", "Drum", "Mic", "Camera",
  "Webcam", "Film", "Tv", "Monitor", "Computer", "Laptop", "Smartphone",
  "Tablet", "Keyboard", "Mouse", "Printer", "Refrigerator", "Fan",
  "Snowflake", "Flame", "Fuel", "Bike", "Car", "Plane", "Luggage",
  "Dumbbell", "Gamepad2", "Puzzle", "Gift", "BadgePercent", "PawPrint",
  "Shirt", "Wheat", "Sprout", "Flower", "Flower2", "ChefHat", "Utensils",
  "UtensilsCrossed", "CookingPot", "Cookie", "Croissant", "IceCream",
  "IceCream2", "Candy", "Baby", "Shield", "Lock",
];

// FNV-1a-ish stable hash for deterministic ordering.
function hash(str: string): number {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = (h * 16777619) >>> 0;
  }
  return h;
}

function lookupIcon(name: string): LucideIcon | null {
  return ICON_REGISTRY[name] ?? null;
}

// Module-level shared state populated from category list.
const map = new Map<number, LucideIcon>();
// ps_id → category icon image URL (from DB), resolved with ancestor fallback.
const iconUrlMap = new Map<number, string>();
// ps_id → category name.
const nameMap = new Map<number, string>();
let version = 0;
const listeners = new Set<() => void>();
// Signature of the last category list processed; lets repeat calls with
// identical data skip the expensive rebuild.
let lastSignature = -1;
const notify = () => {
  version++;
  for (const l of listeners) l();
};

export function buildCategoryIconMap(
  categories: {
    ps_id: number;
    name: string;
    parent_ps_id?: number | null;
    icon_url?: string | null;
  }[],
): void {
  if (categories.length === 0) return;

  // The icon mapping is O(categories × rules × keywords) and was previously
  // recomputed on every call — including the many times this runs with the
  // exact same category data (Header on every page + each route's useMemo,
  // navigations re-using the cached query result). That full recompute showed
  // up as a ~96ms main-thread task and a top INP contributor. Guard with a
  // cheap O(n) signature so identical input returns instantly.
  let sig = 2166136261 ^ categories.length;
  for (const c of categories) {
    sig = (sig * 16777619) >>> 0;
    sig ^= c.ps_id;
    sig = (sig * 16777619) >>> 0;
    sig ^= (c.parent_ps_id ?? -1) & 0xffffffff;
    sig = (sig * 16777619) >>> 0;
    sig ^= c.icon_url ? 1 : 0;
    sig = (sig * 16777619) >>> 0;
    const name = c.name ?? "";
    for (let i = 0; i < name.length; i++) {
      sig ^= name.charCodeAt(i);
      sig = (sig * 16777619) >>> 0;
    }
  }
  if (sig === lastSignature) return;
  lastSignature = sig;

  // Build name + icon-url maps (icon falls back to nearest ancestor's icon).
  const byId = new Map(categories.map((c) => [c.ps_id, c]));
  nameMap.clear();
  iconUrlMap.clear();
  for (const c of categories) {
    nameMap.set(c.ps_id, c.name ?? "");
    let node: typeof c | undefined = c;
    const seen = new Set<number>();
    while (node && !seen.has(node.ps_id)) {
      seen.add(node.ps_id);
      if (node.icon_url) { iconUrlMap.set(c.ps_id, node.icon_url); break; }
      node = node.parent_ps_id != null ? byId.get(node.parent_ps_id) : undefined;
    }
  }

  // Stable order: by ps_id ascending → top-level / earlier categories get
  // first pick of their preferred icons.
  const sorted = [...categories].sort((a, b) => a.ps_id - b.ps_id);
  const used = new Set<LucideIcon>();
  const next = new Map<number, LucideIcon>();

  for (const c of sorted) {
    const lname = (c.name ?? "").toLowerCase();
    let chosen: LucideIcon | null = null;

    for (const rule of RULES) {
      if (!rule.keywords.some((k) => lname.includes(k))) continue;
      for (const iconName of rule.icons) {
        const icon = lookupIcon(iconName);
        if (icon && !used.has(icon)) {
          chosen = icon;
          break;
        }
      }
      if (chosen) break;
    }

    if (!chosen) {
      // Hash-based deterministic pick from the fallback pool.
      const h = hash(`${c.ps_id}:${lname}`);
      const start = h % FALLBACK_POOL.length;
      for (let i = 0; i < FALLBACK_POOL.length; i++) {
        const icon = lookupIcon(FALLBACK_POOL[(start + i) % FALLBACK_POOL.length]);
        if (icon && !used.has(icon)) {
          chosen = icon;
          break;
        }
      }
    }

    if (!chosen) {
      // Last resort: scan the curated icon registry for an unused one.
      for (const icon of REGISTRY_ICONS) {
        if (!used.has(icon)) {
          chosen = icon;
          break;
        }
      }
    }

    if (chosen) {
      used.add(chosen);
      next.set(c.ps_id, chosen);
    }
  }

  // Replace map and notify only if anything changed.
  let changed = next.size !== map.size;
  if (!changed) {
    for (const [k, v] of next) if (map.get(k) !== v) { changed = true; break; }
  }
  if (!changed) return;
  map.clear();
  for (const [k, v] of next) map.set(k, v);
  notify();
}

const subscribe = (cb: () => void) => {
  listeners.add(cb);
  return () => { listeners.delete(cb); };
};
const getSnapshot = () => version;

export function useCategoryIcon(psId: number | null | undefined): LucideIcon | null {
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  if (psId == null) return null;
  return map.get(psId) ?? null;
}

export function getCategoryIconByPsId(psId: number | null | undefined): LucideIcon | null {
  if (psId == null) return null;
  return map.get(psId) ?? null;
}

export function useCategoryIconUrl(psId: number | null | undefined): string | null {
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  if (psId == null) return null;
  return iconUrlMap.get(psId) ?? null;
}

export function getCategoryIconUrl(psId: number | null | undefined): string | null {
  if (psId == null) return null;
  return iconUrlMap.get(psId) ?? null;
}

export function getCategoryName(psId: number | null | undefined): string | null {
  if (psId == null) return null;
  return nameMap.get(psId) ?? null;
}

// --- Greeklish slug helpers ------------------------------------------------
const GREEK_MAP: Record<string, string> = {
  α: "a", ά: "a", β: "v", γ: "g", δ: "d", ε: "e", έ: "e", ζ: "z", η: "i", ή: "i",
  θ: "th", ι: "i", ί: "i", ϊ: "i", ΐ: "i", κ: "k", λ: "l", μ: "m", ν: "n", ξ: "x",
  ο: "o", ό: "o", π: "p", ρ: "r", σ: "s", ς: "s", τ: "t", υ: "y", ύ: "y", ϋ: "y",
  ΰ: "y", φ: "f", χ: "ch", ψ: "ps", ω: "o", ώ: "o",
};

export function slugifyGreeklish(name: string | null | undefined): string {
  const lower = (name ?? "").toLowerCase();
  let out = "";
  for (const ch of lower) out += GREEK_MAP[ch] ?? ch;
  return out
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** Builds the category route slug: "<ps_id>-<greeklish-name>". */
export function categorySlug(
  psId: number,
  name?: string | null,
): string {
  const resolved = name ?? getCategoryName(psId) ?? "";
  const tail = slugifyGreeklish(resolved);
  return tail ? `${psId}-${tail}` : `${psId}`;
}

/** Extracts the numeric category ps_id from a slug like "3-trofima". */
export function parseCategoryId(slug: string): number {
  return parseInt(slug, 10);
}